import { ModerationDashConfig } from "structure/moderation-dash";
import { Feature } from "util/stdtypes";

export const PostAnywayFilterFeature : Feature<ModerationDashConfig, {}> = {
    name: 'Post Anyway Filter',
    key: 'post_anyway_filter',
    dev: true,
    providesConfig: {
        modFilters: [
            {
                label: '!Posted Anyway',
                filter: item => item?.object?.minorViolation,
            }
        ]
    }
}

